import React, { useState, useEffect } from "react";
import { Formik } from "formik";
import SelectDropdown from "../../../../../components/common-components/selectDropdown";
import Input from "../../../../../components/common-components/input/Input";
import Button from "../../../../../components/common-components/button/Button";
import { BUTTON_VARIANTS } from "../../../../../components/common-components/button/Constants";
import ModalComponent from "../../../../../components/common-components/modal/ModalComponent";
import { APPOINTMENT_REASON_OPTIONS, APPOINTMENT_STATUS_OPTIONS, FORM_FIELDS_FOR_APPOINTMENT, SERVICE_CATEGORY_OPTIONS } from "../Constants";
import { getValidationSchema } from "../../../../../libs/formsUtils";
import ItemManager from "../ItemManager";
import AddSpecificType from "../AddSpecificType";
import Label from "../../../../../components/common-components/label/Label";
import HealthRecordHelper from "../utils/utils";
import AppointmentParticipant from "./AppointmentParticipant";

const fields = [
    { fieldName: FORM_FIELDS_FOR_APPOINTMENT.STATUS, isRequired: true, isDropdown: true },
    { fieldName: FORM_FIELDS_FOR_APPOINTMENT.START, isRequired: true },
    { fieldName: FORM_FIELDS_FOR_APPOINTMENT.END, isRequired: true },
    { fieldName: FORM_FIELDS_FOR_APPOINTMENT.DESCRIPTION, isRequired: true },
];

const validationSchema = getValidationSchema(fields);

const Appointment = ({ open, close, onConfirm, optionField = true }) => {

    const [serviceList, setServiceList] = useState([]);
    const [specialityList, setSpecialityList] = useState([]);
    const [participantList, setParticipantList] = useState([]);

    const [isServicePopupOpen, setIsServicePopupOpen] = useState(false);
    const [isSpecialityPopupOpen, setISSpecialityPopupOpen] = useState(false);
    const [isParticipantPopupOpen, setIsParticipantPopupOpen] = useState(false)
    const [participantError, setParticipantError] = useState("");

    useEffect(() => {
        if(participantList.length > 0) setParticipantError("")
    },[participantList])
    return (
        <>
            <Formik
                initialValues={{
                    [FORM_FIELDS_FOR_APPOINTMENT.STATUS]: "",
                    [FORM_FIELDS_FOR_APPOINTMENT.SERVICE_CATEGORY]: "",
                    [FORM_FIELDS_FOR_APPOINTMENT.SERVICE_TYPE]: "",
                    [FORM_FIELDS_FOR_APPOINTMENT.SPECIALITY]: "",
                    [FORM_FIELDS_FOR_APPOINTMENT.APPOINTMENT_TYPE]: "",
                    [FORM_FIELDS_FOR_APPOINTMENT.REASON_CODE]: "",
                    [FORM_FIELDS_FOR_APPOINTMENT.START]: "",
                    [FORM_FIELDS_FOR_APPOINTMENT.END]:"",
                    [FORM_FIELDS_FOR_APPOINTMENT.PARTICIPANT_TYPE]: "",
                    [FORM_FIELDS_FOR_APPOINTMENT.DESCRIPTION]: "",
                }}
                validationSchema={validationSchema}
                onSubmit={(values) => {
                    if(participantList.length <= 0) {
                        setParticipantError("Atleast 1 participant is required")
                        return;
                    }
                    const appointmentData = {
                        resourceType: "Appointment",
                        status: values[FORM_FIELDS_FOR_APPOINTMENT.STATUS].value,
                        serviceCategoryText: values[FORM_FIELDS_FOR_APPOINTMENT.SERVICE_CATEGORY] && {
                            code: values[FORM_FIELDS_FOR_APPOINTMENT.SERVICE_CATEGORY].value,
                            display: values[FORM_FIELDS_FOR_APPOINTMENT.SERVICE_CATEGORY].label,
                        },
                        serviceType: serviceList.map((service) => ({ text: service.data })),
                        specialty: specialityList.map((speciality) => ({ text: speciality.data })),
                        appointmentTypeText: values[FORM_FIELDS_FOR_APPOINTMENT.APPOINTMENT_TYPE] && {
                            code: values[FORM_FIELDS_FOR_APPOINTMENT.APPOINTMENT_TYPE].value,
                            display: values[FORM_FIELDS_FOR_APPOINTMENT.APPOINTMENT_TYPE].label,
                        },
                        reasonCode: values[FORM_FIELDS_FOR_APPOINTMENT.REASON_CODE],
                        start: values[FORM_FIELDS_FOR_APPOINTMENT.START],
                        end: values[FORM_FIELDS_FOR_APPOINTMENT.END],
                        description: values[FORM_FIELDS_FOR_APPOINTMENT.DESCRIPTION],
                        participant: participantList.map((participant) =>  participant.data),
                    };
                    const formattedData = HealthRecordHelper.removeEmptyFields(appointmentData)
                    onConfirm((prev) => [...prev, { type: `Appointment ${prev.length + 1}`, data: formattedData}]);
                    close();
                }}
            >
                {({ values, errors, setFieldValue, handleSubmit, handleBlur }) => (
                    
                    <ModalComponent
                        open={open}
                        title={"Add Appointment"}
                        footerButton={
                            <Button
                                variant={BUTTON_VARIANTS.CONTAINED}
                                onClickCb={() => handleSubmit()}
                            >
                                Submit
                            </Button>
                        }
                        close={close}
                        customClasses="w-[90%] max-w-[800px]"
                        customBodyClasses="overflow-visible"
                    >
                        <div className="grid grid-cols-2 gap-4">
                            <SelectDropdown
                                label="Appointment Status"
                                name={FORM_FIELDS_FOR_APPOINTMENT.STATUS}
                                customClasses="w-full"
                                isRequired={true}
                                placeholder="Select"
                                value={values[FORM_FIELDS_FOR_APPOINTMENT.STATUS]}
                                options={APPOINTMENT_STATUS_OPTIONS}
                                onChangeCb={(selectedOption) =>
                                    setFieldValue(FORM_FIELDS_FOR_APPOINTMENT.STATUS, selectedOption)
                                }
                            />
                            {/* <Input
                                label="Service Category"
                                placeholder="Please enter service category text"
                                name={FORM_FIELDS_FOR_APPOINTMENT.SERVICE_CATEGORY}
                                value={values[FORM_FIELDS_FOR_APPOINTMENT.SERVICE_CATEGORY]}
                                onChangeCb={(e) =>
                                    setFieldValue(FORM_FIELDS_FOR_APPOINTMENT.SERVICE_CATEGORY, e.target.value)
                                }
                                onBlurCb={handleBlur}
                            /> */}
                            {optionField && <SelectDropdown
                                label="Service Category"
                                name={FORM_FIELDS_FOR_APPOINTMENT.SERVICE_CATEGORY}
                                customClasses="w-full"
                                isRequired={true}
                                placeholder="Select"
                                value={values[FORM_FIELDS_FOR_APPOINTMENT.SERVICE_CATEGORY]}
                                options={SERVICE_CATEGORY_OPTIONS}
                                onChangeCb={(selectedOption) =>
                                    setFieldValue(FORM_FIELDS_FOR_APPOINTMENT.SERVICE_CATEGORY, selectedOption)
                                }
                            />}
                           {optionField &&
                           <>
                             <ItemManager
                                title="Service Type"
                                items={serviceList}
                                setItems={setServiceList}
                                setIsPopupOpen={setIsServicePopupOpen}
                                customHeight="52"
                            />
                            <ItemManager
                                title="Specialty"
                                items={specialityList}
                                setItems={setSpecialityList}
                                setIsPopupOpen={setISSpecialityPopupOpen}
                                customHeight="52"
                            />
                           </>
                           }
                            {/* <Input
                                label="Appointment Type"
                                placeholder="The style of appointment or patient that has been booked in the slot (not service type)"
                                name={FORM_FIELDS_FOR_APPOINTMENT.APPOINTMENT_TYPE}
                                value={values[FORM_FIELDS_FOR_APPOINTMENT.APPOINTMENT_TYPE]}
                                onChangeCb={(e) =>
                                    setFieldValue(FORM_FIELDS_FOR_APPOINTMENT.APPOINTMENT_TYPE, e.target.value)
                                }
                                onBlurCb={handleBlur}
                            /> */}
                            {optionField && <SelectDropdown
                                label="Appointment Type"
                                name={FORM_FIELDS_FOR_APPOINTMENT.APPOINTMENT_TYPE}
                                customClasses="w-full"
                                isRequired={true}
                                placeholder="Select"
                                value={values[FORM_FIELDS_FOR_APPOINTMENT.APPOINTMENT_TYPE]}
                                options={APPOINTMENT_REASON_OPTIONS}
                                onChangeCb={(selectedOption) =>
                                    setFieldValue(FORM_FIELDS_FOR_APPOINTMENT.APPOINTMENT_TYPE, selectedOption)
                                }
                            />}
                            {optionField && <Input
                                label="Reason code/text"
                                placeholder="Please enter reason code/text"
                                name={FORM_FIELDS_FOR_APPOINTMENT.REASON_CODE}
                                value={values[FORM_FIELDS_FOR_APPOINTMENT.REASON_CODE]}
                                onChangeCb={(e) =>
                                    setFieldValue(FORM_FIELDS_FOR_APPOINTMENT.REASON_CODE, e.target.value)
                                }
                                onBlurCb={handleBlur}
                            />}
                            
                            <Input
                                label="Start Time"
                                name={FORM_FIELDS_FOR_APPOINTMENT.START}
                                type="datetime-local"
                                isRequired={true}
                                value={values[FORM_FIELDS_FOR_APPOINTMENT.START]}
                                onChangeCb={(e) => setFieldValue(FORM_FIELDS_FOR_APPOINTMENT.START, e.target.value)}
                                onBlurCb={handleBlur}
                            />
                            <Input
                                label="End Time"
                                name={FORM_FIELDS_FOR_APPOINTMENT.END}
                                type="datetime-local"
                                isRequired={true}
                                value={values[FORM_FIELDS_FOR_APPOINTMENT.END]}
                                onChangeCb={(e) => setFieldValue(FORM_FIELDS_FOR_APPOINTMENT.END, e.target.value)}
                                onBlurCb={handleBlur}
                            />
                            <Input
                                label="Description"
                                name={FORM_FIELDS_FOR_APPOINTMENT.DESCRIPTION}
                                placeholder="Enter description"
                                isRequired={true}
                                value={values[FORM_FIELDS_FOR_APPOINTMENT.DESCRIPTION]}
                                onChangeCb={(e) => setFieldValue(FORM_FIELDS_FOR_APPOINTMENT.DESCRIPTION, e.target.value)}
                                onBlurCb={handleBlur}
                            />
                            <div className="col-span-2">
                                <ItemManager
                                    title={<>Participants <span className="text-red-500">*</span></>} 
                                    items={participantList}
                                    setItems={setParticipantList}
                                    setIsPopupOpen={setIsParticipantPopupOpen}
                                    customHeight="52"
                                />
                                {participantError && (
                                    <Label fontSize="sm" fontWeight="bold" color="red-500">
                                        {participantError}
                                    </Label>
                                )}
                            </div>
                            
                        </div>
                    </ModalComponent>
                )}
            </Formik>
            {isServicePopupOpen && 
                <AddSpecificType
                    open={isServicePopupOpen}
                    close={() => setIsServicePopupOpen(false)}
                    label={"Service Type"}
                    placeholder={"The specific service that is to be performed during this appointment"}
                    setList={setServiceList}
                    name={FORM_FIELDS_FOR_APPOINTMENT.SERVICE_TYPE}
                />
            }
            {isSpecialityPopupOpen && 
                <AddSpecificType
                    open={isSpecialityPopupOpen}
                    close={() => setISSpecialityPopupOpen(false)}
                    label={"Specialty"}
                    placeholder={"The specialty of a practitioner that would be required to perform the service requested in this appointment"}
                    setList={setSpecialityList}
                    name={FORM_FIELDS_FOR_APPOINTMENT.SPECIALITY}
                />
            }
            {isParticipantPopupOpen && 
                <AppointmentParticipant
                    open={isParticipantPopupOpen}
                    close={() => setIsParticipantPopupOpen(false)}
                    onConfirm={setParticipantList}
                />
            }
        </>
    );
};

export default Appointment;
